import { sendContainerRequest } from '@/container'
import type { Package } from '../types/types'
export type GetPackagesForSubAccountResponse = {
    success: boolean
    packages: Package[]
    error?: string
}

export async function getPackagesForSubAccount(
    userId: string,
    subAccountId: string,
    studioId: string
): Promise<GetPackagesForSubAccountResponse> {
    return sendContainerRequest('getPackagesForSubAccount', {
        userId,
        subAccountId,
        studioId,
    })
        .then(
            (result: {
                data: {
                    success: boolean
                    packages: any[]
                    error?: string
                }
            }) => {
                if (result.data.success) {
                    return result.data
                }
                return { success: false, error: result.data.error }
            }
        )
        .catch((err: any) => ({ success: false, error: err }))
}
